import { Link } from "react-router";
import { useAiStatus, useGoals } from "../lib/queries";

export function Goals() {
  const goals = useGoals();
  const ai = useAiStatus();

  return (
    <>
      <header className="page-header row">
        <h1>Metas</h1>
        <div className="row gap">
          <Link to="/habitos" className="btn">Hábitos</Link>
          {ai.data?.enabled && <Link to="/metas/nueva" className="btn primary">+ Nueva</Link>}
        </div>
      </header>

      {ai.data && !ai.data.enabled && (
        <p className="banner">La IA todavía no está activada en este servidor.</p>
      )}

      {goals.isPending ? (
        <p className="muted center">Cargando…</p>
      ) : (goals.data ?? []).length === 0 ? (
        <div className="empty card">
          <p>
            Escribe algo que quieras lograr a largo plazo y la IA lo convierte en pasos pequeños en tu
            calendario.
          </p>
          {ai.data?.enabled && <Link to="/metas/nueva" className="btn primary">Crear mi primera meta</Link>}
        </div>
      ) : (
        <ul className="list">
          {goals.data!.map((g) => (
            <li key={g.id}>
              <Link to={`/metas/${g.id}`} className="goal card" style={{ borderLeftColor: g.color }}>
                <div className="goal-title">{g.title}</div>
                <div className="muted small">
                  {g.progress.scheduled > 0
                    ? `Esta semana: ${g.progress.done} de ${g.progress.scheduled}`
                    : `${g.habitIds.length} ${g.habitIds.length === 1 ? "paso" : "pasos"}`}
                  {g.targetDate ? ` · para el ${g.targetDate.split("-").reverse().join("/")}` : ""}
                </div>
                {g.progress.needsReplan && (
                  <div className="small" style={{ color: "var(--primary)", marginTop: 6 }}>
                    ¿Lo hacemos más fácil? Toca para ajustar el plan.
                  </div>
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
